module.exports = __webpack_public_path__ + "img/minifruehlingsrollemithintergrund.fd1a263d.jpg";